import React from 'react';
import PropTypes from 'prop-types';
import { enGB } from 'date-fns/locale';
import { DateRangePicker, START_DATE, END_DATE } from 'react-nice-dates';

import 'react-nice-dates/build/style.css';
import DatePresenter, { RANGE_FORMAT } from '../../presenters/DatePresenter';

const RangePicker = (props) => {
  const { startDate, endDate, onStartDateChange, onEndDateChange } = props;
  return (
    <DateRangePicker
      startDate={DatePresenter.dateObject(startDate)}
      endDate={DatePresenter.dateObject(endDate)}
      onStartDateChange={(e) => {
        onStartDateChange(e);
      }}
      onEndDateChange={(e) => {
        onEndDateChange(e);
      }}
      minimumLength={1}
      format={RANGE_FORMAT}
      locale={enGB}
    >
      {({ startDateInputProps, endDateInputProps, focus }) => (
        <div className="date-range">
          <input
            className={'input' + (focus === START_DATE ? '-focused' : '')}
            {...startDateInputProps}
            placeholder="Start date"
          />
          <span className="date-range_arrow" />
          <input
            className={'input' + (focus === END_DATE ? '-focused' : '')}
            {...endDateInputProps}
            placeholder="End date"
          />
        </div>
      )}
    </DateRangePicker>
  );
};

export default RangePicker;

RangePicker.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  onStartDateChange: PropTypes.func.isRequired,
  onEndDateChange: PropTypes.func.isRequired,
};

RangePicker.defaultProps = {
  startDate: null,
  endDate: null,
};
